import { readItem, writeItem, checkSettings } from "./storage.js";
import cn from "./locales/cn.js";
import de from "./locales/de.js";
import de_de from "./locales/de_de.js";
import dk from "./locales/dk.js";
import el from "./locales/el.js";
import en from "./locales/en.js";
import es from "./locales/es.js";
import fr from "./locales/fr.js";
import hi from "./locales/hi.js";
import hu from "./locales/hu.js";
import it from "./locales/it.js";
import msa from "./locales/msa.js";
import nl from "./locales/nl.js";
import no from "./locales/no.js";
import pt from "./locales/pt.js";
import rm from "./locales/rm.js";
import ro from "./locales/ro.js";
import ru from "./locales/ru.js";
import se from "./locales/se.js";
import tr from "./locales/tr.js";

export const locales = { cn, de, de_de, dk, el, en, es, fr, hi, hu, it, msa, nl, no, pt, rm, ro, ru, se, tr };

/** Aktive Sprache: gespeichert, sonst Geraetesprache; per Einstellung ueberlagerbar. */
export function currentLanguage() {
    if (readItem("language", "localStorage") === "") {
        writeItem("language", navigator.language, "localStorage");
    }

    let language = readItem("language", "localStorage");

    const overlay = checkSettings("lang_overlay_" + language);
    if (overlay !== "") language = overlay;

    language = language.replace(/-/g, "_");
    if (!locales[language]) language = language.substring(0, 2);
    if (!locales[language]) language = "en";
    return language;
}

export function localizeStr(key) {
    const language = currentLanguage();
    // Reihenfolge: Sprache -> Basissprache (de_de -> de) -> Englisch -> Schluesselname
    for (const table of [locales[language], locales[language.substring(0, 2)], locales.en]) {
        if (table && table[key]) return table[key];
    }
    return key;
}
